import Udesk from 'Udesk';
import React, { FC, memo, useMemo } from 'react';
import { Tabs } from 'udesk-ui';
import { Wrapper, Title, Content } from './components';
import ScoreTab from './components/ScoreTab';
import PaneContent from './components/PaneContent';
import { computeTotalScore } from './utils';
import { Category, InspectionDataWrapper, LeafCategory } from '../../../../../api/types';

interface CategoryExtend extends Category {
    totalScore?: number;
}

interface TemplateProps {
    inspectDetail?: InspectionDataWrapper;
    playSpecificTimePeriod?: (start: number, end: number) => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { inspectDetail, playSpecificTimePeriod } = props;

    const pointCategoryList: CategoryExtend[] = useMemo(() => {
        if (!inspectDetail) {
            return [];
        }

        const { task, pointCategoryList } = computeTotalScore(
            inspectDetail,
            inspectDetail?.pointCategoryList ?? []
        );

        return [
            {
                id: 'total',
                name: '总分',
                score: inspectDetail?.score ?? 0,
                children: inspectDetail?.pointCategoryList?.reduce((pre, cur) => {
                    return [...pre, ...(cur?.children ?? [])];
                }, [] as LeafCategory[]),
                _maxScore: task._maxScore,
                _minScore: task._minScore,
            },
            ...pointCategoryList,
        ].map((category) => {
            return {
                ...category,
                totalScore: Udesk.business.scoreCompute.formatTotalScore(category),
                children: category.children?.map((leafCategory) => {
                    return {
                        ...leafCategory,
                        pointDataList: leafCategory.pointDataList?.map((point) => {
                            return {
                                ...point,
                                _hidden: Object.keys(inspectDetail?.complaintInfoHashMap ?? {})
                                    .map(Number)
                                    .includes(point.pointId ?? 0),
                            };
                        }),
                    };
                }),
            };
        });
    }, [inspectDetail]);

    return (
        <Wrapper>
            <Title>得分详情</Title>

            <Content>
                <Tabs
                    tabPosition="left"
                    type="card"
                    style={{ height: '100%' }}
                    defaultActiveKey="total"
                    destroyInactiveTabPane
                >
                    {pointCategoryList?.map((category) => (
                        <Tabs.TabPane
                            tab={
                                <ScoreTab
                                    label={category.name}
                                    score={category.score ?? 0}
                                    totalScore={category.totalScore ?? 0}
                                />
                            }
                            key={category.id}
                        >
                            <PaneContent
                                inspectDetail={inspectDetail}
                                playSpecificTimePeriod={playSpecificTimePeriod}
                                category={category}
                            />
                        </Tabs.TabPane>
                    ))}
                </Tabs>
            </Content>
        </Wrapper>
    );
});

export default Template;
